export function countdownToEvent(eventDate: Date): { days: number; hours: number; minutes: number; seconds: number } {
  const date =
    eventDate instanceof Date
      ? eventDate
      : (() => {
          const normalized = (eventDate as string)?.replace(/(T\d{2}:\d{2})([-+Z])/, "$1:00$2");
          return new Date(normalized);
        })();

  const currentDate: Date = new Date();
  const timeDifference: number = date.getTime() - currentDate.getTime();

  if (timeDifference < 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 }; // Event has already passed
  }

  const totalSeconds: number = Math.floor(timeDifference / 1000);
  const days: number = Math.floor(totalSeconds / (60 * 60 * 24));
  const hours: number = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
  const minutes: number = Math.floor((totalSeconds % (60 * 60)) / 60);
  const seconds: number = Math.floor(totalSeconds % 60);

  return { days, hours, minutes, seconds };
}
